import requestAction from '../../utils/requestAction'

export const uploadComplaintInternalMessageFile = (formData: FormData, complaintId: number, handleResponse: (fileId: string) => void) =>
  requestAction('COMPLAINT_INTERNAL_MESSAGE_UPLOADFILE')(
    `complaints/internal/message/upload/${complaintId}`,
    'POST',
    formData,
    undefined,
    'file',
    (_dispatch, _getState, response) => { if (response && handleResponse) handleResponse(response.fileId) })

